import { render, staticRenderFns } from "./Partner.vue?vue&type=template&id=bd7de95a&scoped=true&"
import script from "./Partner.vue?vue&type=script&lang=js&"
export * from "./Partner.vue?vue&type=script&lang=js&"
import style0 from "./Partner.vue?vue&type=style&index=0&id=bd7de95a&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7de95a",
  null
  
)

export default component.exports